module.exports = "<section class=\"panel\" [ngClass]=\"{\n'custom': type===displayTypes.FullWidth,\n'floating':type===displayTypes.Float,\n'no-overflow':!overflow\n}\">\n  <header *ngIf=\"title\" class=\"title\">{{title}}</header>\n  <div class=\"inner main\">\n    <ng-content></ng-content>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-base/components/panel/panel.component.html
// module id = ../../../../../src/app/modules/ui-base/components/panel/panel.component.html
// module chunks = main